module.exports = __webpack_public_path__ + "static/media/Cylinder.1d3d8ca4.kra";